import { createClient } from '@supabase/supabase-js';
import { hasSupabaseConfig, supabaseUrl, publicAnonKey } from '/utils/supabase/info';

const fallbackSupabaseUrl = 'https://missing-supabase-project.supabase.co';
const fallbackAnonKey = 'missing-supabase-anon-key';

if (!hasSupabaseConfig) {
  console.warn(
    'Supabase environment variables are missing. Remote data features will stay unavailable until the web build is created with VITE_SUPABASE_PROJECT_ID or VITE_SUPABASE_URL, plus VITE_SUPABASE_ANON_KEY.'
  );
}

export const supabase = createClient(
  hasSupabaseConfig ? supabaseUrl : fallbackSupabaseUrl,
  hasSupabaseConfig ? publicAnonKey : fallbackAnonKey
);
